module.exports = __webpack_public_path__ + "static/img/ctswugcqi_1.6c0d2d87.png";